module.exports = __webpack_public_path__ + "img/emoji_bzzt.8a0430c7.png";